import React from 'react';
import { Box, Typography, Grid, Card, CardContent, Tooltip } from '@mui/material';
import { WorkspacePremium, ArrowForwardIos } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import './WallOfAchievements.css';

const WallOfAchievements = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const achievementWalls = [
    {
      id: 'Certificates-and-Achievements',
      title: 'Certification Wall ',

      icon: <WorkspacePremium sx={{ fontSize: 40 }} />,
      className: 'certificate-wall',
      route: '/certificates',
    },
  ];

  const handleCardClick = (route) => {
    if (route === '/certificates') {
      // Navigate to CertificateList using the correct route
      navigate('/home/announcement/gbox/certificate-wall');
    } else {
      // For other walls, show coming soon or implement as needed
      console.log(`Navigate to ${route}`);
    }
  };

  return (
    <Box className="wallOfAchievementsContainer">
      <Grid container spacing={3} className="achievementGrid">
        {achievementWalls.map((wall) => (
          <Grid item xs={12} sm={6} md={4} key={wall.id}>
            <Tooltip title={`View ${wall.title}`}>
              <Card className={`achievementCard ${wall.className}`} onClick={() => handleCardClick(wall.route)}>
                <CardContent className="achievementCardContent">
                  <Box className="achievement-icon">{wall.icon}</Box>

                  <Box className="achievementText">
                    <Typography variant="h6" className="achievementTitle">
                      {wall.title}
                    </Typography>
                  </Box>

                  <ArrowForwardIos className="click-indicator" />
                </CardContent>
              </Card>
            </Tooltip>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WallOfAchievements;
